const ssoNonceStorageKey = "sso_nonce";

/**
 * Generate a cryptographic nonce (64 hex chars = 32 bytes).
 *
 * @returns {string}
 */
export function generateSSONonce() {
	const bytes = new Uint8Array(32);
	crypto.getRandomValues(bytes);
	return Array.from(bytes, b => b.toString(16).padStart(2, "0")).join("");
}

/**
 * Store the SSO nonce for later validation.
 *
 * @param {string} nonce
 */
export function storeSSONonce(nonce) {
	localStorage.setItem(ssoNonceStorageKey, nonce);
}

/**
 * Retrieve and clear the stored SSO nonce and check it against `nonce`.
 *
 * @param {string} nonce
 * @returns {boolean}
 */
export function consumeSSONonce(nonce) {
	const stored = localStorage.getItem(ssoNonceStorageKey);
	localStorage.removeItem(ssoNonceStorageKey);
	return stored === nonce;
}
